import {
  IconShieldCheck,
  IconRefresh,
  IconCalendarTime,
  IconArrowUpCircle,
} from "@tabler/icons-react";
import { policyItems } from "./data";
import styles from "../subscriptionPayment.module.css";

const ICONS = [
  IconShieldCheck,
  IconRefresh,
  IconCalendarTime,
  IconArrowUpCircle,
];

export default function PolicyStrip() {
  return (
    <div className={styles.policyStrip}>
      {policyItems.map((item, i) => {
        const Icon = ICONS[i];
        return (
          <div className={styles.policyItem} key={item.title}>
            <Icon size={20} style={{ color: item.iconColor }} />
            <h5>{item.title}</h5>
            <p>{item.text}</p>
          </div>
        );
      })}
    </div>
  );
}
